var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-table-simple",
        {
          ref: "detailGrid",
          attrs: { bordered: "", responsive: "", "sticky-header": "" },
        },
        [
          _c("colgroup", [
            _c("col", { staticStyle: { width: "150px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
            _c("col", { staticStyle: { width: "100px" } }),
          ]),
          _c(
            "b-thead",
            { attrs: { "head-variant": "light" } },
            [
              _c(
                "b-tr",
                [
                  _c("b-th", { staticClass: "sticky-header" }, [
                    _vm._v(" 상세 코드 "),
                  ]),
                  _c("b-th", { staticClass: "sticky-header" }, [
                    _vm._v(" 게시글 노출 수 "),
                  ]),
                  _c("b-th", [_vm._v(" 게시글 클릭 수 ")]),
                  _c("b-th", [_vm._v(" 시청 알림 팝업 노출 수 ")]),
                  _c("b-th", [_vm._v(" 시청 알림 팝업 클릭 수 ")]),
                  _c("b-th", [_vm._v(" 스케줄 알림 팝업 노출 수 ")]),
                  _c("b-th", [_vm._v(" 스케줄 알림 팝업 클릭 수 ")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.data.length > 0
            ? _c(
                "b-tbody",
                [
                  _vm._l(_vm.data, function (member, index) {
                    return [
                      _c(
                        "b-tr",
                        { key: "member-" + member.entryCode + "-" + index },
                        [
                          _c("b-td", [_vm._v(_vm._s(member.entryCode))]),
                          _c("b-td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("$numberFormatter")(
                                  member.homePopupShowCount
                                )
                              )
                            ),
                          ]),
                          _c("b-td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("$numberFormatter")(
                                  member.homePopupClickCount
                                )
                              )
                            ),
                          ]),
                          _c("b-td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("$numberFormatter")(
                                  member.noticePopupShowCount
                                )
                              )
                            ),
                          ]),
                          _c("b-td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("$numberFormatter")(
                                  member.noticePopupClickCount
                                )
                              )
                            ),
                          ]),
                          _c("b-td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("$numberFormatter")(
                                  member.schedulePopupShowCount
                                )
                              )
                            ),
                          ]),
                          _c("b-td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("$numberFormatter")(
                                  member.schedulePopupClickCount
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  }),
                ],
                2
              )
            : _c(
                "b-tbody",
                [
                  _c(
                    "b-tr",
                    [
                      _c(
                        "b-td",
                        { staticClass: "text-center", attrs: { colspan: 7 } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.contentId == null
                                  ? "게시글을 선택해 주세요"
                                  : "데이터가 없습니다"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }